var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift-message p-2 mb-2"},[_c('img',{attrs:{"src":_vm.url,"alt":"Geschenk"},on:{"load":function($event){return _vm.$bus.$emit('new-message')}}}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }